import translator from 'src/translate'
import React, { useState } from 'react'
import Webhook from './tabs/webhook-settings'
import SeoSettings from './tabs/seo-settings'
import styles from './styles'
import { withStyles } from '@material-ui/core/styles'
import { Drawer, Tab, Typography } from '@material-ui/core'
import { TabContext, TabList, TabPanel } from '@material-ui/lab'
import AdvancedSettings from './tabs/advanced-settings'
import GeneralSettings from './tabs/basics-settings'
import LanguageSettings from './tabs/language-settings'
import { Icon } from '@iconify/react'
import { useSelector, useDispatch } from 'react-redux'
import { settingsDrawerOpenSuccess } from 'src/reducers/course/action'

const SettingsDrawer = props => {
  const { classes } = props
  const dispatch = useDispatch()

  const settingsDrawerOpen = useSelector(
    state => state.course.settingsDrawerOpen,
  )

  const [currentTab, setCurrentTab] = useState('0')
  const isUserPremium = Number(window.CONSTANTS.USER_ROLE_ID) !== 1

  const handleTabChange = (event, newValue) => setCurrentTab(newValue)

  const SettingsTabs = [
    /*    {
      label: 'General',
      component: <SeoSettings />,
      disabled: false,
    }, */

    {
      label: 'Advanced',
      component: <AdvancedSettings />,
      enabled: true,
    },
    {
      label: translator._('assignment.courseSettings.webhook'),
      component: <Webhook />,
      disabled: false,
    },
    {
      label: 'Language',
      component: <LanguageSettings />,
      enabled: true,
    },
  ]

  const handleDrawerClose = () => {
    dispatch(settingsDrawerOpenSuccess())
  }
  return (
    <div>
      <Drawer
        variant="temporary"
        anchor="right"
        classes={{ paper: classes.drawer }}
        open={settingsDrawerOpen}
        onClose={() => handleDrawerClose()}
        onOpen={() => handleDrawerClose()}
        transitionDuration={{ enter: 700, exit: 700 }}
      >
        <div className={classes.list}>
          <div>
            <TabContext value={currentTab}>
              <Typography
                fontWeight={450}
                fontSize="16px"
                fontFamily="Inter"
                style={{ textAlign: 'center', marginTop: '25px' }}
              >
                Settings
              </Typography>
              <TabList
                centered
                onChange={handleTabChange}
                className={classes.tabList}
                variant="scrollable"
                TabIndicatorProps={{
                  style: { background: '#00AB55' },
                }}
              >
                {SettingsTabs.map((value, index) => {
                  return (
                    <Tab
                      key={index}
                      label={value.label}
                      icon={value.icon}
                      value={index.toString()}
                      className={classes.tab}
                      disabled={value.disabled}
                    />
                  )
                })}
              </TabList>

              {SettingsTabs.map((value, index) => {
                return (
                  <TabPanel
                    className={classes.tabContainer}
                    key={index}
                    value={index.toString()}
                    hidden={Number(currentTab) !== Number(index)}
                  >
                    {value.component}
                  </TabPanel>
                )
              })}
            </TabContext>
          </div>
        </div>
      </Drawer>
    </div>
  )
}

export default withStyles(styles)(SettingsDrawer)
